import { AnyAction, Middleware, Reducer } from 'redux';
import { ISagaModule } from 'redux-dynamic-modules-saga';
import { ISagaRegistration } from 'redux-dynamic-modules-saga/lib/Contracts';

import { validateNamespace } from '../validateNamespace/validateNamespace';

export interface IModuleFactory {
    (): ISagaModule<any>;
}

export interface IModuleFactoryOptions {
    middlewares?: Middleware[];
    initialActions?: AnyAction[];
    finalActions?: AnyAction[];
    retained?: boolean;
}

export function createModuleFactory<TState> (namespace: string, reducer: Reducer<TState>, sagas: ISagaRegistration<any>[] = [], options: IModuleFactoryOptions = {}): IModuleFactory {
    validateNamespace(namespace);

    return (): ISagaModule<any> => {
        return {
            id: namespace,
            reducerMap: {
                [namespace]: reducer,
            },
            sagas: sagas,
            ...options,
        };
    };
}